import React, { useState } from "react";
import { Button, VStack } from "@chakra-ui/react";
import { PlusIcon } from "lucide-react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import PostFlow, { AliasType } from "./PostFlow";
import AdminToolbar from "../Admin/AdminToolbar";
import { Role, useSessionState } from "../../Session/SessionService";

export function Postings(props: {
  showLegend: boolean;
  category: string;
  alias?: AliasType;
}) {
  const [openPostCreationModal, setOpenPostCreationModal] =
    useState<boolean>(false);
  const [disableEdit, setDisableEdit] = useState<boolean>(true);
  const session = useSessionState();

  return (
    <VStack align={"left"}>
      {session.hasUserMode(Role.ADMIN) && (
        <AdminToolbar
          hidden={false}
          onOpen={() => setDisableEdit(false)}
          onClose={() => setDisableEdit(true)}
        >
          <Button
            leftIcon={<PlusIcon />}
            onClick={() => {
              setOpenPostCreationModal(true);
            }}
          >
            Nytt inlägg
          </Button>
        </AdminToolbar>
      )}
      <PostFlow
        onLoadedPosts={() => {}}
        showLegend={props.showLegend}
        category={props.category}
        selectedUserMode={disableEdit ? null : session.getUserMode()}
        alias={props.alias}
        openPostCreationModal={openPostCreationModal}
        setOpenPostCreationModal={setOpenPostCreationModal}
      />
    </VStack>
  );
}
